﻿export interface IInvoiceHeaderDescription {
    showAbbreviation: boolean,
    annualMembershipFeeDescr: string,
    dcnAnnualMembershipFeeDescr: string,
    rmcrNonComplianceDescr: string,
    customLineItemDescr: string,
    dashMonthlyFeeDescr: string,
    dashMonthlyFeeLiverDescr: string,
    matchingFeeDescr: string,
    dashFeeDescr: string,
    transplantTypingFeeDescr: string,
    kidneyShippingFeeDescr: string,
    logisticsSupportFeeDescr: string,
    serologyFeeDescr: string,
    serologyFeeDirectDescr: string,
    kitFulfillmentSerologyDescr: string,
    kitFulfillmentXmFreshDescr: string,
    opoPackagingAndPerfusionDescr: string,
    researchSupportDescr: string,
    donorInsuranceAndSupportDescr: string,
    donorInsuranceAndSupportLiverDescr: string,
    donorShieldCreditsDescr: string,
    donorShieldCreditsLiverDescr: string,
    ccbHospitalNephrectomyDescr: string,
    ccbDonorWorkupDescr: string,
    kitFulfillmentHomeBloodDrawDescr: string,
    kitFulfillmentTypingDescr: string,
    kitFulfillmentTypingAndCryoDescr: string,
    donorShieldDescr: string,
    liverDonorShieldDescr: string,
    pwlQuestFeeDescr: string,
    pwlPhlebotKitDescr: string,
    remoteDirectRiskPremiumDescr: string,
    incompatiblePairRiskPremiumDescr: string,
    privateInsuranceRiskPremiumDescr: string,
    pwlPerTransplantFeeDescr: string,
    rmcrNonComplianceMajorDescr: string,
    rmcrNonComplianceMinorDescr: string,
    monthlyInactivityFeeDescr: string,
    stateTaxesDescr: string,
    lostGpsFeeDescr: string
}
